<template>
  <div class="header">
    <div class="nav">
      <div class="logo">
        <img src="../assets/img/logo.png" @click="goHome()" />
      </div>
      <el-menu
        :default-active="activeIndex"
        background-color="#DFF1FF"
        text-color="#000"
        active-text-color="#fff"
        mode="horizontal"
        :router="true"
      >
        <div
          class="submenu"
          v-for="(item, i) in routeMenu"
          :key="i"
          @click="handleSelect(i)"
        >
          <el-menu-item
            style="color:#000000;"
            :index="item.index"
            :route="{
              path: item.index,
              query: { code: item.code, type: item.type },
            }"
            :class="{ active: curIndex == i }"
            >{{ item.name }}</el-menu-item
          >
        </div>
      </el-menu>
      <div class="kaiBiaoDaTingBox" @click="goKaiBiaoDaTing">
        <div><img src="../assets/img/kaibiaodating_icon.png" />开标大厅</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderMenu",
  props: {},
  data() {
    return {
      activeIndex: "0",
      curIndex: "0",
      routeMenu: [
        {
          index: "home",
          name: "首页",
        },
        // {
        //   index: "gongsigaikuang",
        //   name: "公司概况",
        // },
        // {
        //   index: "xinwenzhongxin",
        //   name: "新闻中心",
        //   children: [
        //     {
        //       index: "GongSiDongTai",
        //       name: "公司动态",
        //       code: "800002001",
        //     },
        //     {
        //       index: "GongSiDongTai",
        //       name: "行业资讯",
        //       code: "800002002",
        //     },
        //     {
        //       index: "GongSiDongTai",
        //       name: "综合要闻",
        //       code: "800002003",
        //     },
        //     {
        //       index: "GongSiDongTai",
        //       name: "通知公告",
        //       code: "800002004",
        //     },
        //   ],
        // },
        {
          index: "ZhaoBiaoDaiLi",
          name: "招标信息",
          type: 1,
        },
        {
          index: "ZhaoBiaoDaiLi",
          name: "政府采购",
          type: 2,
        },
        // {
        //   index: "ZhengCeFaGui",
        //   name: "政策法规",
        // },
        // {
        //   index: "GongSiDongTai",
        //   name: "招贤纳士",
        //   code: "800006",
        // },
        // {
        //   index: "LianXiWoMen",
        //   name: "联系我们",
        // },{
        //   index: "jiandutousu",
        //   name: "监督投诉",
        // },
      ],
      type:'',
    };
  },
  watch:{
    "$route.query.type"(val){
      this.type = val
    },
    "$route.path"(val){
      if(val == "/ZhaoBiaoDaiLi" || val=="/ZBDLDetailInfo"){
        if(this.type == 1){
        this.curIndex = 1;
        }else{
          this.curIndex = 2;
        }
      }else if(val == "/home"){
        this.curIndex = 0;
      }
    }
  },
  methods: {
    goKaiBiaoDaTing() {
      window.open(
        `https://zbt.haopan.net/web/website/kaibiao/kaibiaodating.html?tenantid=${this.$store.state.ztbTenantID}&t=${Math.random()}`
      );
    },
    handleSelect(index) {
      this.curIndex = index;
    },
    goHome() {
      // this.curIndex="-1";
      // this.$router.push('/');
      // this.$router.go(0);
    },
  },
};
</script>
<style scoped lang="scss">
.header {
  background: #dff1ff;
}
.banner {
  width: 100%;
}

.nav {
  height: 60px;
  // background-color: $theme-color;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  position: relative;
  // justify-content: space-between;
  .logo {
    margin: 5px;
  }
  .kaiBiaoDaTingBox {
    position: absolute;
    right: 0;
    top: 14px;
    width: 360px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    div {
      width: 92px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #2976ce;
      color: #2976ce;
      font-size: 12px;
      border-radius: 2px;
    }
    img {
      width: 14px;
      margin-right: 6px;
    }
  }
  ul {
    margin-left: 50px;
    display: flex;
    // justify-content: center;
    li {
      width: 140px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: $color-white;
      cursor: pointer;
      font-size: 16px;
      //  font-weight: 600;
      // &:hover {
      //   background: url(../assets/img/nav_active.png) no-repeat center 38px;
      // }
    }
  }
  ::v-deep .el-submenu__title {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    font-weight: 600;
  }
  ::v-deep .el-submenu__title i {
    color: #fff;
    margin-top: -4px;
  }
  ::v-deep .el-menu--inline {
    z-index: 99;
  }
  ::v-deep .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 0px solid #409eff;
  }
  ::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: 0px solid #409eff;
  }
}

.active {
  color: #fff !important;
  font-weight: bold;
  background-color: $theme-color !important;
}
</style>
